import React from "react";
import BlockLogoGrid from "../../blocks/logo/block.logo.grid";

export function LandingLogoGridElement({ assets, data, color }) {
  return <BlockLogoGrid color={color} data={data} assets={assets} />;
}
